module.exports = __webpack_public_path__ + "img/图片4-1.3eecdddf.png";